import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=016437f0&"
import script from "./ProductPicker.vue?vue&type=script&lang=ts&"
export * from "./ProductPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports